var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container page-guide" }, [
    _c("div", { staticClass: "row p-sm bg-color-login" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "text-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("h4", [
              _vm._v("Amazonとの連携に関しては\n            "),
              _c(
                "a",
                {
                  staticClass: "text--underline",
                  attrs: {
                    href: _vm.downloadUrl,
                    download: "",
                    target: "_blank"
                  }
                },
                [_c("span", [_vm._v("こちら")])]
              ),
              _vm._v("\n          をご参照ください")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "back" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-block",
              on: { click: _vm.toHome }
            },
            [_vm._v("セールモンスターを始める")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h4", [_vm._v("ご利用ありがとうございます。")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b495e8b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b495e8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Guide.vue
// module id = null
// module chunks = 